// third party imports
import React, { useState, useEffect, useContext } from "react";

// internal rebet imports
import "./stylesCustomerSupportControls.css";

import { SIDER_TABS } from "../../../utils/Constants";
import AffiliatePanelInstance from "../../../api/AffiliatePanelInstance";

import IconChat from "../../../assets/icons/ic_chat.svg";
import IconSupport from "../../../assets/icons/ic_support.svg";


// component imports
import RebetLoader from "../../CommonComponents/RebetLoader/RebetLoader";
import createPrivateAdminPanelInstance from "../../../api/PrivateAdminPanelInstance";
import { API_ROUTES } from "../../../api/ApiRoutes";
import Layout from "../../CommonComponents/Layout/Layout";
import AppContext from "../../../context/AppContext";
import { message } from "antd";

// asset imports

const CustomerSupportControls = () => {
  // non-state variables
  const token = JSON.parse(localStorage.getItem("token"));
  const PrivateAdminPanelInstance = createPrivateAdminPanelInstance(
    token?.IdToken
  );

  const { setActiveSidebarTab } = useContext(AppContext);

  // state variables
  const [messageApi, contextHolder] = message.useMessage();
  const [isApiRunning, setIsApiRunning] = useState(false);
  const [supportChatMode, setSupportChatMode] = useState("");

  // use effects

  // api functions
  const getSupportControls = async () => {
    setIsApiRunning(true);

    const params = {
      variable_name: "support_chat_mode",
    };

    try {
      const response = await PrivateAdminPanelInstance?.post(
        API_ROUTES?.GET_GLOBAL_VARIABLE,
        params
      );
      const data = response?.data.data;
      setSupportChatMode(data?.value);

      setIsApiRunning(false);
    } catch (error) {
      setIsApiRunning(false);
      console.log("error getting support chat mode", error);
    }
  };

  useEffect(() => {
    getSupportControls();
  }, []);

  useEffect(() => {
    setActiveSidebarTab(SIDER_TABS.ADMIN, "Customer Support Controls");
  }, [setActiveSidebarTab]);

  // helper functions
  const handleSupportChatModeChange = async (mode) => {
    setIsApiRunning(true);

    const params = {
      variable_name: "support_chat_mode",
      value: mode,
    };

    try {
      const response = await PrivateAdminPanelInstance?.post(
        API_ROUTES?.SET_GLOBAL_VARIABLE,
        params
      );

      const data = response?.data.data;
      console.log("Updated support chat mode", data);
      messageApi.success("Support chat mode updated successfully.");
      setSupportChatMode(mode);

      setIsApiRunning(false);
    } catch (error) {
      setIsApiRunning(false);
      console.log("error setting support chat mode", error);
    }
  };
  return (
    <Layout name={SIDER_TABS.ADMIN}>
      <div className="customer-support-controls-body-container">
        {contextHolder}
        <div className="customer-support-controls-content">
          <div className="head-controls">
            <div className="header-text-container">
              <p className="header-text">HelpDesk/LiveChat Toggle</p>
            </div>
          </div>

          <div className="customer-support-controls-toggle-container">
            {isApiRunning ? (
              <RebetLoader height={"100px"} width={"100px"} />
            ) : (
              <>
                <div className="selected-mode-container">
                  <p className="selected-mode-label">Selected Mode:</p>
                  <p className="selected-mode-value">
                    {supportChatMode === "chat" ? "LiveChat" : "HelpDesk"}
                  </p>
                </div>
                <div className="support-chat-mode-container">
                  <div
                    className={`support-chat-mode-item ${
                      supportChatMode === "ticket" ? "selected" : ""
                    }`}
                    onClick={() => handleSupportChatModeChange("ticket")}
                  >
                    <img
                      src={IconSupport}
                      alt="support-chat-mode"
                      width={30}
                      height={30}
                    />
                  </div>
                  <div
                    className={`support-chat-mode-item ${
                      supportChatMode === "chat" ? "selected" : ""
                    }`}
                    onClick={() => handleSupportChatModeChange("chat")}
                  >
                    <img
                      src={IconChat}
                      alt="support-chat-mode"
                      width={30}
                      height={30}
                    />
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default CustomerSupportControls;
